exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.sc-consolidate-lp[data-v-61c38788] {\n  padding-bottom: 0;\n  min-height: 500px;\n}\n", "", {"version":3,"sources":["/usr/src/app/node_modules/@intelipost-modules/secure-recon/features/analytics/components/analytics-consolidated-lp/ScAnalyticsConsolidatedLp.vue"],"names":[],"mappings":";AACA;EACE,kBAAkB;EAClB,kBAAkB;CACnB","file":"ScAnalyticsConsolidatedLp.vue","sourcesContent":["\n.sc-consolidate-lp[data-v-61c38788] {\n  padding-bottom: 0;\n  min-height: 500px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-61c38788","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/@intelipost-modules/secure-recon/features/analytics/components/analytics-consolidated-lp/ScAnalyticsConsolidatedLp.vue
// module id = l03j
// module chunks = 72